import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { GangSheetBuilder } from '../components/GangSheetBuilder';
import { ArtworkInstructions } from '../components/ArtworkInstructions';
import { ServicesGrid } from '../components/ServicesGrid';
import { WhyPrintAtomic } from '../components/WhyPrintAtomic';
import { ProcessSection } from '../components/ProcessSection';
import { FeaturedWork } from '../components/FeaturedWork';
import { CTABand } from '../components/CTABand';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-atomic-black text-white selection:bg-atomic-green selection:text-black" data-id="element-209">
      <Header data-id="element-210" />
      <main data-id="element-211">
        <Hero data-id="element-212" />
        <GangSheetBuilder data-id="element-213" />
        <ArtworkInstructions data-id="element-214" />
        <ServicesGrid data-id="element-215" />
        <WhyPrintAtomic data-id="element-216" />
        <ProcessSection data-id="element-217" />
        <FeaturedWork data-id="element-218" />
        <CTABand data-id="element-219" />
      </main>
      <Footer data-id="element-220" />
    </div>;
}